import { render } from "./index.vue?vue&type=template&id=cc98ac66"
import script from "./oracleOurPartner?vue&type=script&lang=js&external"
export * from "./oracleOurPartner?vue&type=script&lang=js&external"

import "./oracleOurPartner.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__